import { Router, Request, Response } from "express";
import asyncHandler from "express-async-handler";

import { favoriteList, favoriteAdd, favoriteDelete } from "./favorites";
import { login } from "./login";
import { ratingsList } from "./ratings";
import { shoppingList } from "./shoppingList";

const router = Router();

router.post(
	"/login",
	asyncHandler(async (req: Request, res: Response) => login(req, res)),
);

router.get(
	"/:userID/favorites",
	asyncHandler(async (req: Request, res: Response) => favoriteList(req, res)),
);
router.post(
	"/:userID/favorites",
	asyncHandler(async (req: Request, res: Response) => favoriteAdd(req, res)),
);
router.delete(
	"/:userID/favorites",
	asyncHandler(async (req: Request, res: Response) => favoriteDelete(req, res)),
);

router.get(
	"/:userID/ratings",
	asyncHandler(async (req: Request, res: Response) => ratingsList(req, res)),
);

router.get(
	"/:userID/ratings",
	asyncHandler(async (req: Request, res: Response) => ratingsList(req, res)),
);

router.get(
	"/:userID/shoppingList",
	asyncHandler(async (req: Request, res: Response) => shoppingList(req, res)),
);

export default router;
